<template>
    <header>
        <site-top-bar></site-top-bar>
        <div class="headerBottomArea">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-3 col-xs-9">
                        <a href="/" class="logo">
                            <img src="../../assets/images/favicon-128.png" alt=""/>
                        </a>
                    </div>
                    <div class="col-md-8 menuCol col-sm-9 col-xs-9">
                        <div class="navbar-header">
                            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                                    data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                                <span class="sr-only"></span>
                                <i class="fa fa-navicon"></i>
                            </button>
                        </div>
                        <site-menu></site-menu>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import SiteTopBar from './SiteTopBar'
import SiteMenu from './SiteMenu'

export default {
  components: {
    SiteMenu,
    SiteTopBar
  },
  name: 'site-header'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/site/SiteHeader.vue